"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = exports.DomainJsonMapper = exports.DomainDynamoMapper = void 0;
var domain_dynamodb_1 = require("./domain-dynamodb");
Object.defineProperty(exports, "DomainDynamoMapper", { enumerable: true, get: function () { return domain_dynamodb_1.DomainDynamoMapper; } });
var domain_json_1 = require("./domain-json");
Object.defineProperty(exports, "DomainJsonMapper", { enumerable: true, get: function () { return domain_json_1.DomainJsonMapper; } });
var domain_model_1 = require("./domain-model");
Object.defineProperty(exports, "Domain", { enumerable: true, get: function () { return domain_model_1.Domain; } });
